import { useEffect, useState } from "react";
import { IPredectiveContainerProps } from "./Predective.interfaces";
import PredectiveView from "./Predective.view";
import BroswerService from "../../Services/Browser.service";
export default function PredectiveContainer(props: IPredectiveContainerProps) {
    // Scroll to specific section function
    const scrollToPredictiveSection = (sectionId: string) => {
        const element = document.getElementById(sectionId);
        if (element) {
            element.scrollIntoView({
                behavior: 'smooth',
                block: 'start'
            });

            // Add highlight effect
            element.classList.add('scroll-highlight');
            setTimeout(() => {
                element.classList.remove('scroll-highlight');
            }, 2000);
        }
    };

    useEffect(() => {
        BroswerService.setCustomTitle("PredectiveContainer");

        // Check if there's a pending scroll request from navigation
        const pendingScrollSection = sessionStorage.getItem('scrollToPredictiveSection');
        if (pendingScrollSection) {
            // Wait a bit for the component to fully render
            setTimeout(() => {
                scrollToPredictiveSection(pendingScrollSection);
                sessionStorage.removeItem('scrollToPredictiveSection');
            }, 800); // Increased timeout to ensure all content is loaded
        }
    }, []);
    const [showDemo, setShowDemo] = useState(false);
    const demoController = () => setShowDemo(!showDemo);
    const [showlogin, setShowlogin] = useState(false);
    const loginController = () => setShowlogin(!showlogin);
    return (
        <>
            <PredectiveView
                demoController={demoController}
                showDemo={showDemo}
                loginController={loginController}
                showlogin={showlogin}
                scrollToPredictiveSection={scrollToPredictiveSection}
            />
        </>
    );
}
